'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFlask = function IoIosFlask(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.5 29.9c0.4 0.6 0.7 1.4 0.7 1.9 0 0.6-0.3 1.1-0.6 1.4-0.4 0.3-1 0.6-1.8 0.6h-17.6c-0.9 0-1.6-0.2-1.9-0.5-0.1-0.1-0.5-0.4-0.5-1.4 0-0.5 0.3-1.4 0.7-2l5.3-8.6h10.5l5.2 8.6z m3.6-1c0.7 1.3 0.9 2.5 0.9 3.6-0.1 2.8-2.1 5-4.9 5h-20c-2.8 0-5-2.1-5.1-5 0-1.1 0.3-2.3 0.9-3.6l9.1-15.2v-9.9h-1.2v-1.3h12.5v1.3h-1.3v9.9z m-17.8-23.9v1.3h3.7v-1.3h-3.7z m0 3.8v1.2h2.5v-1.2h-2.5z m0 3.7v1.3h3.7v-1.3h-3.7z m-1.4 3.8l-0.7 1.2h4.6v-1.2h-3.9z m17.5 15.6c0-0.7-0.2-1.7-0.8-2.6l-5.6-9.3h-12l-5.6 9.3c-0.5 0.9-0.8 1.9-0.8 2.6 0 2.2 1.2 3.1 3.6 3.1h17.6c2.4 0 3.5-1.2 3.6-3.1z' })
        )
    );
};

exports.default = IoIosFlask;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-flask.js
// module id = 2396
// module chunks = 0